/*
Controller: Impersonate

Operations:
  createImpersonation
  endImpersonation
  getImpersonateReasons
*/
var Api = require('../config')
var ImpersonationDef = require('../definitions/Impersonation')

var Impersonate = (function () {
  /*
  Operation: createImpersonation
  Create impersonation
  Parameters:
    bodyRequest: impersonation object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Impersonation creation failed
    HTTP 403: Operation not permitted
  */
  function createImpersonationImpersonate (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        ImpersonationDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/createImpersonation'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: endImpersonation
  End impersonation
  Parameters:
  Responses:
    HTTP 200: End impersonation done and revert the support user session back to the original user
    HTTP 403: Operation not permitted
  */
  function endImpersonationImpersonate () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/impersonate'
      Api
        .request({
          url: path,
          method: 'delete'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getImpersonateReasons
  Get all reasons for impersonation
  Parameters:
  Responses:
    HTTP 200: list of reasons for impersonation
    HTTP 403: Operation not permitted
  */
  function getImpersonateReasonsImpersonate () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/impersonate/reasons'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createImpersonation'] = createImpersonationImpersonate
  ret['endImpersonation'] = endImpersonationImpersonate
  ret['getImpersonateReasons'] = getImpersonateReasonsImpersonate
  return ret
})()

module.exports = Impersonate
